/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  Modal,
  Typography,
  message,
  Form,
  Button,
} from 'antd';
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import FormSubmitCustomControls from 'components/FormSubmitCustomControls';
import { ActionsNames, hasActionPermission } from 'utils/permission';
import { getCatalogoDeEfectivo } from 'api/catalogos';
import toCurrency from 'utils/toCurrency';
import NumericInput from 'components/NumericInput';

const { Text } = Typography;

const Calculadora = ({
  visible,
  setVisible,
  callback,
}) => {
  const [catEfectivo, setCatEfectivo] = useState([]);
  const [form] = Form.useForm();
  const [hasAllViewPermission, setHasAllViewPermission] = useState(true);
  const sortMonedas = (a, b) => a.es_billete.toString().localeCompare(b.es_billete);
  const [total, setTotal] = useState(0);

  const onCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  useEffect(() => {
    let mounted = true;
    const validatePermissions = () => {
      const _hasAllViewPermission = hasActionPermission('catalogodemetododepago',
        ActionsNames.view);
      if (!_hasAllViewPermission) {
        message.warn('Hacen falta permisos en los catálogos relacionados a este módulo');
      }
      if (mounted) {
        setHasAllViewPermission(_hasAllViewPermission);
      }
    };
    const fetchData = async () => {
      const _catalogoDeEfectivo = await getCatalogoDeEfectivo();
      if (mounted) {
        setCatEfectivo(_catalogoDeEfectivo.sort(sortMonedas).filter((e) => e.id !== 11));
      }
    };
    validatePermissions();
    fetchData();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onFinish = async () => {
    callback(total);
    onCancel();
  };

  const controls = [
    {
      onClick: () => setVisible(false),
      icon: <ArrowRightOutlined />,
      text: 'Salir',
    },
    {
      onClick: () => onFinish(),
      icon: <PlusOutlined />,
      text: 'Cargar',
    },

  ];

  const focusInput = (currentInput) => {
    const input = document.getElementById(currentInput);
    if (input) {
      input.focus();
    }
  };

  return (
    <Modal
      visible={visible}
      closable={false}
      footer={null}
      title={(
        <Row justify="space-between" className="container">
          <Text>
            Total :
            {' '}
            {toCurrency(total)}
          </Text>
          <FormSubmitCustomControls
            controls={!hasAllViewPermission ? [{
              onClick: () => onCancel(),
              icon: <ArrowLeftOutlined />,
              text: 'Regresar',
            }] : controls}
          />
        </Row>
      )}
      onCancel={onCancel}
      forceRender
      centered
    >
      <Form
        form={form}
        layout="vertical"
        name="form"
        onFinish={() => onFinish()}
        onValuesChange={(changedValues, allValues) => {
          const changed = Object.keys(changedValues).shift();
          const {
            moneda_1,
            moneda_2,
            moneda_3,
            moneda_4,
            moneda_5,
            moneda_6,
            moneda_7,
            moneda_8,
            moneda_9,
            moneda_10,
            moneda_11,
            moneda_12,
          } = allValues;
          let ttl = 0;
          if (moneda_1) {
            ttl += (parseInt(moneda_1, 10) || 0) * 20;
          }
          if (moneda_2) {
            ttl += (parseInt(moneda_2, 10) || 0) * 50;
          }
          if (moneda_3) {
            ttl += (parseInt(moneda_3, 10) || 0) * 100;
          }
          if (moneda_4) {
            ttl += (parseInt(moneda_4, 10) || 0) * 200;
          }
          if (moneda_5) {
            ttl += (parseInt(moneda_5, 10) || 0) * 500;
          }
          if (moneda_6) {
            ttl += (parseInt(moneda_6, 10) || 0) * 1000;
          }
          if (moneda_7) {
            ttl += (parseInt(moneda_7, 10) || 0) * 0.5;
          }
          if (moneda_8) {
            ttl += (parseInt(moneda_8, 10) || 0);
          }
          if (moneda_9) {
            ttl += (parseInt(moneda_9, 10) || 0) * 2;
          }
          if (moneda_10) {
            ttl += (parseInt(moneda_10, 10) || 0) * 10;
          }
          if (moneda_11) {
            ttl += (parseInt(moneda_11, 10) || 0) * 20;
          }
          if (moneda_12) {
            ttl += (parseInt(moneda_12, 10) || 0) * 5;
          }
          setTotal(ttl);
          setTimeout(() => {
            focusInput(changed);
          });
        }}
      >
        <Row gutter={12}>
          {catEfectivo.sort((a, b) => b.denominacion - a.denominacion).map((moneda) => moneda && (
          <Col span={8} key={moneda.id}>
            <NumericInput
              name={`moneda_${moneda.id}`}
              label={`${toCurrency(moneda.denominacion)} ${moneda.id === 11 ? '(Moneda)' : ''}`}
            />
          </Col>
          ))}
          <Form.Item hidden>
            <Button htmlType="submit" />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
};

Calculadora.propTypes = {
  setVisible: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  callback: PropTypes.func.isRequired,
};

Calculadora.defaultProps = {
  visible: false,
};

export default Calculadora;
